var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAlarm0(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_alarm0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_alarm0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    fill: "#B1B1B1",
    cx: 7,
    cy: 7,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.948,11.12 C8.02,11.12 8.818,10.824 9.342,10.232 C9.866,9.64 10.152,8.864 10.2,7.904 C10.216,7.472 10.224,7.104 10.224,6.8 C10.224,6.496 10.216,6.12 10.2,5.672 C10.16,4.728 9.872,3.96 9.336,3.368 C8.8,2.776 8.004,2.48 6.948,2.48 C5.892,2.48 5.096,2.776 4.56,3.368 C4.024,3.96 3.736,4.728 3.696,5.672 C3.69,5.84 3.68625,6.0935 3.68475,6.4325 L3.68475,7.1615 C3.68625,7.4945 3.69,7.742 3.696,7.904 C3.744,8.864 4.03,9.64 4.554,10.232 C5.078,10.824 5.876,11.12 6.948,11.12 Z M6.948,9.716 C6.452,9.716 6.08,9.554 5.832,9.23 C5.584,8.906 5.452,8.444 5.436,7.844 C5.43028571,7.67828571 5.42661224,7.44930612 5.42497959,7.15706122 L5.42497959,6.39689796 C5.42661224,6.10791837 5.43028571,5.88628571 5.436,5.732 C5.452,5.148 5.584,4.692 5.832,4.364 C6.08,4.036 6.452,3.868 6.948,3.86 C7.444,3.868 7.816,4.036 8.064,4.364 C8.312,4.692 8.444,5.148 8.46,5.732 C8.468,5.948 8.472,6.296 8.472,6.776 C8.472,7.256 8.468,7.612 8.46,7.844 C8.444,8.444 8.312,8.906 8.064,9.23 C7.816,9.554 7.444,9.716 6.948,9.716 Z",
    id: 0,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlarm0);
export default __webpack_public_path__ + "static/media/icon_alarm0.907dbc5e2153e0a3ba35659931e9cf0f.svg";
export { ForwardRef as ReactComponent };